<template>
  <!--
    Região viva PERMANENTE: existe no DOM desde a montagem da tela e só o TEXTO muda.

    É essa a diferença que faz a mensagem ser anunciada. O leitor de tela registra as
    regiões vivas presentes na página e passa a observá-las; uma região criada junto com o
    seu conteúdo (`<div v-if="carregando" role="status">`) frequentemente não é observada a
    tempo, e o anúncio simplesmente não sai. É o erro mais comum de mensagem dinâmica, e
    nenhuma ferramenta de página o detecta — no DOM final o markup parece correto
    (WCAG 4.1.3 — Mensagens de Estado).

    `.regiao-anuncio` (folha global) mantém o elemento fora da tela e sem ocupar espaço: o
    indicador VISUAL continua sendo o spinner da tela, que fica com `aria-hidden`. Quem
    enxerga vê o spinner; quem usa leitor de tela ouve esta região. Ninguém recebe os dois.

    `polite` de propósito: `assertive` interromperia a leitura em curso a cada carregamento,
    o que numa tela que carrega várias listas em sequência é ruído contínuo.
  -->
  <p class="regiao-anuncio" role="status" aria-live="polite" aria-atomic="true">
    {{ ativo ? mensagem : concluido }}
  </p>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'RegiaoStatus',
    props: {
      /** Quando verdadeiro, a região passa a anunciar `mensagem`. */
      ativo: {
        type: Boolean,
        default: false,
      },
      /** O que anunciar enquanto `ativo`. */
      mensagem: {
        type: String,
        default: 'Carregando...',
      },
      /**
       * O que anunciar quando `ativo` volta a falso.
       *
       * Vazio por padrão: na maioria dos casos quem anuncia o fim do carregamento é o
       * próprio conteúdo que chegou (a região viva do ConsulteGrid, por exemplo, diz
       * "48 registros encontrados"). Anunciar "concluído" além disso faria o leitor de
       * tela falar duas vezes sobre o mesmo evento.
       */
      concluido: {
        type: String,
        default: '',
      },
    },
  });
</script>
